/**
 *
 * @param {import('synapse-common-device-service/AppSync/generated/types').Status} status
 * @param {Boolean} inSession
 * @returns
 */

export default function calculateStatus(status, inSession) {
  if ((inSession && status !== 'Offline') || status === 'InSession') {
    return 'In Session';
  }

  return status;
}
